export enum ESortTypes {
	date,
	name,
	discount,
	specialOffers,
	onlyNew,
}